"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizeProvider = SizeProvider;
exports.useSize = useSize;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _styledComponents = require("styled-components");
var _react = _interopRequireDefault(require("react"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useSize() {
  var _useTheme;
  var size = (_useTheme = (0, _styledComponents.useTheme)()) === null || _useTheme === void 0 ? void 0 : _useTheme.size;
  if (!size) {
    throw new Error('useSize must be used within a ThemeProvider');
  }
  return size;
}
function SizeProvider(_ref) {
  var size = _ref.size,
    children = _ref.children,
    additionalThemeProps = _ref.additionalThemeProps;
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: _objectSpread({
      size: size
    }, additionalThemeProps)
  }, children);
}
//# sourceMappingURL=SizeProvider.js.map